import React from 'react';
import { MapPinIcon, StarIcon, ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface VenueCardProps {
  id: string;
  name: string;
  location: string;
  image: string;
  rating: number;
  reviews: number;
  totalCourts: number;
  availableCourts: number;
  priceRange: {
    min: number;
    max: number;
  };
  priceRangeUC: {
    min: number;
    max: number;
  };
  amenities: string[];
}
export function VenueCard({
  id,
  name,
  location,
  image,
  rating,
  reviews,
  totalCourts,
  availableCourts,
  priceRange,
  priceRangeUC,
  amenities
}: VenueCardProps) {
  const navigate = useNavigate();
  const isAvailable = availableCourts > 0;
  return <button onClick={() => navigate(`/venue/${id}`)} className="w-full bg-white rounded-2xl shadow-lg overflow-hidden active:scale-98 transition-transform text-left" data-id="element-197">
      {/* Venue Image */}
      <div className="relative h-48 overflow-hidden" data-id="element-198">
        <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-199" />

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-200" />

        {/* Location Badge */}
        <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm rounded-full px-3 py-1.5 flex items-center gap-1.5 shadow-lg" data-id="element-201">
          <MapPinIcon className="w-3.5 h-3.5 text-[#3dc7e3]" data-id="element-202" />
          <span className="text-xs font-bold text-[#1f5070]" data-id="element-203">{location}</span>
        </div>

        {/* Rating Badge */}
        <div className="absolute top-3 right-3 bg-white/95 backdrop-blur-sm rounded-full px-3 py-1.5 flex items-center gap-1.5 shadow-lg" data-id="element-204">
          <StarIcon className="w-3.5 h-3.5 fill-[#FFB300] text-[#FFB300]" data-id="element-205" />
          <span className="text-xs font-bold text-[#1f5070]" data-id="element-206">{rating}</span>
        </div>

        {/* Venue Name Overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-207">
          <h3 className="text-xl font-bold text-white drop-shadow-lg" data-id="element-208">
            {name}
          </h3>
        </div>
      </div>

      {/* Venue Details */}
      <div className="p-4" data-id="element-209">
        {/* Availability Status */}
        <div className="flex items-center justify-between mb-3" data-id="element-210">
          <div className="flex items-center gap-2" data-id="element-211">
            {isAvailable ? <>
                <div className="w-2 h-2 bg-[#43A047] rounded-full animate-pulse" data-id="element-212" />
                <span className="text-sm font-bold text-[#43A047]" data-id="element-213">
                  {availableCourts} of {totalCourts} courts available
                </span>
              </> : <>
                <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-214" />
                <span className="text-sm font-medium text-gray-400" data-id="element-215">
                  Fully booked
                </span>
              </>}
          </div>
          <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-216" />
        </div>

        {/* Price Range */}
        <div className="mb-3" data-id="element-217">
          <span className="text-lg font-bold text-[#3dc7e3]" data-id="element-218">
            {priceRangeUC.min}-{priceRangeUC.max} UC
          </span>
          <span className="text-sm text-[#666666]" data-id="element-219">
            {' '}
            or ${priceRange.min}-${priceRange.max}/hour
          </span>
        </div>

        {/* Amenities Pills */}
        <div className="flex flex-wrap gap-2" data-id="element-220">
          {amenities.slice(0, 3).map((amenity, index) => <span key={index} className="text-xs font-medium text-[#1f5070] bg-[#f8f9fa] px-2.5 py-1 rounded-full" data-id="element-221">
              {amenity}
            </span>)}
          {amenities.length > 3 && <span className="text-xs font-medium text-[#666666] bg-[#f8f9fa] px-2.5 py-1 rounded-full" data-id="element-222">
              +{amenities.length - 3} more
            </span>}
        </div>

        {/* Reviews */}
        <div className="mt-3 pt-3 border-t border-gray-100" data-id="element-223">
          <span className="text-xs text-[#666666]" data-id="element-224">{reviews} reviews</span>
        </div>
      </div>
    </button>;
}